import React, {Component, useState} from 'react'
import { useTranslation, Trans } from "react-i18next";
import { Pagination, PaginationItem, PaginationLink, Spinner } from 'reactstrap';


const PaginationCont = ({total_pages, current_page=0, children, page_action}) => {
    const [loading, setloading] = useState(false);

    const clickAction = (params) => {
	setloading(true)
	page_action(params).then(() => setloading(false))	    	
    }


    const pagination = () => {
	if(total_pages>2)
	    return Array(parseInt(Math.min(total_pages-2, 9))).fill().map((x,i)=> (Math.min(Math.max(total_pages-10, 1),Math.max(current_page-4, 1))+i))
	else
	    return []
    }

    
    const pages = [0, (current_page >= 5 && total_pages>10 ? null : undefined),...pagination(), (current_page < total_pages-6 && total_pages>10 ? null : undefined), (total_pages>1 ? total_pages-1 : undefined)].filter(x => x!==undefined)

    



    
    
    return <React.Fragment>
    <Pagination className="pull-right">
    {pages.map((x,i) => <PaginationItem  active={current_page==x} key={i}>
	{x!=null ?
	 <PaginationLink onClick={() => clickAction({page: x})}>
	     {x+1}
	 </PaginationLink>
	:
	 '...'
	}
    </PaginationItem>) }
    </Pagination>
    
    <div >
    {loading &&
     <div className='loadPage loader-overlay' style={{position: 'absolute', height: '100%'}}>

	 <Spinner color="primary" />
     </div>}
	    {children}
	</div>
    </React.Fragment>
}

export default PaginationCont
